import { Component, OnInit } from '@angular/core';
import { WindowreffService } from '../services/windowreff.service';

@Component({
  selector: 'app-razorpay',
  templateUrl: './razorpay.component.html',
  styleUrls: ['./razorpay.component.css'],
  providers:[WindowreffService]
})
export class RazorpayComponent implements OnInit {
  finalObj:any={
    customerDetail:{
      name:'',
      phone:'',
      email:''
    },
    cardDetail:{
      cardNumber:'',
      cardExpDate:'',
      cardCvv:'',

    },
    addressDetail:{
      address:'',
      landmark:'',
      city:'',
      state:'',
      pincode:''
    }
  }
  constructor(private winRef: WindowreffService) { }

  ngOnInit() {
    this.payWithRazor()
  }

  payWithRazor(){ 
      let options:any = {
          "key": "rzp_test_dvfpRNEUlLTuCq",
          "amount": 100,
          "name": "Company Name",
          "description": "dummy data",
         // "image": "./assets/images/logo.png",
          "modal": {
            "escape": false
          }, 
          "prefill": {
            "name": this.finalObj.customerDetail.name,
            "contact": this.finalObj.customerDetail.phone,
            "email": this.finalObj.customerDetail.email,
            "method": 'card',
            'card[number]': this.finalObj.cardDetail.cardNumber,
            'card[expiry]': this.finalObj.cardDetail.cardExpDate,
            'card[cvv]': this.finalObj.cardDetail.cardCvv
          },
          "notes": {
            "address": this.finalObj.addressDetail.address + ', ' + this.finalObj.addressDetail.landmark + ', ' + this.finalObj.addressDetail.city + ', ' + this.finalObj.addressDetail.state + '-' + this.finalObj.addressDetail.pincode
          },
          "theme": {
            "color": "#6fbc29"
          }
        };
        options.handler = ((response) => {
          console.log(response)
            options['payment_response_id'] = response.razorpay_payment_id;
          // this.paymentService.payWithRazor({cart: this.finalObj, payment: options});
        });
        options.modal.ondismiss = (() => {
          //  this.loginService.SetLoader = false;
        });
        let rzp = new this.winRef.nativeWindow.Razorpay(options);
        rzp.open();
    }  
    
  }


